import { api } from '../api';
import { GET_SNAPSHOTS } from '../../constants/portfolio';
import { PnlRequestParams, PNLResponse } from './types';

export const pnlSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getSnapshots: build.query<PNLResponse, PnlRequestParams>({
      query: (data) => ({
        url: `${GET_SNAPSHOTS}`,
        method: 'GET',
        // Evaluated per request, not per hook mount: a dashboard left open past midnight
        // polls with the new day instead of the endDate it opened with.
        params: {
          ...data,
          endDate: data.endDate ?? Math.floor(Date.now() / 1000)
        }
      })
    })
  }),
  overrideExisting: false
});

export const { useGetSnapshotsQuery } = pnlSlice;
